import Reports from '@/views/forecasting/reports/Reports.vue'
import MonthlyProjectionReport from '@/views/forecasting/reports/actions/MonthlyProjectionReport.vue'
import MonthlyIncomeProjectionReport from '@/views/forecasting/reports/actions/MonthlyIncomeProjectionReport.vue'
import MonthlyExpensesProjectionReport from '@/views/forecasting/reports/actions/MonthlyExpensesProjectionReport.vue'
import ActualMonthlyReport from '@/views/forecasting/reports/actions/ActualMonthlyReport.vue'
import ActualMonthlyIncomeReport from '@/views/forecasting/reports/actions/ActualMonthlyIncomeReport.vue'
import ActualMonthlyExpensesReport from '@/views/forecasting/reports/actions/ActualMonthlyExpensesReport.vue'
import ConsultantsByEmployer from '@/views/forecasting/reports/actions/ConsultantsByEmployer.vue'
import ConsultantsBySubVendor from '@/views/forecasting/reports/actions/ConsultantsBySubVendor.vue'
import ConsultantsBySupplier from '@/views/forecasting/reports/actions/ConsultantsBySupplier.vue'
import ConsultantsByReferrer from '@/views/forecasting/reports/actions/ConsultantsByReferrer.vue'
import ConsultantsByVendor from '@/views/forecasting/reports/actions/ConsultantsByVendor.vue'
import MissingTimesheetsReport from '@/views/forecasting/reports/actions/MissingTimesheetsReport.vue'
import MissingInvoicesReport from '@/views/forecasting/reports/actions/MissingInvoicesReport.vue'
import InvoicePaymentDueDateReport from '@/views/forecasting/reports/actions/InvoicePaymentDueDateReport.vue'

export default [
  // *===============================================---*
  // *--------- Forecasting -------------------------------*
  // *===============================================---*
  // *------------ Reports --------------------*
  {
    path: '/forecasting/reports',
    name: 'forecasting-reports',
    component: Reports,
    meta: {
      pageTitle: 'Reports',
    },
  },
  // *------------ Monthly Projection Report --------------------*
  {
    path: '/forecasting/reports/monthly-projection-report',
    name: 'forecasting-reports-monthly-projection-report',
    component: MonthlyProjectionReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Monthly Income Projection Report --------------------*
  {
    path: '/forecasting/reports/monthly-income-projection-report',
    name: 'forecasting-reports-monthly-income-projection-report',
    component: MonthlyIncomeProjectionReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Monthly Expenses Projection Report --------------------*
  {
    path: '/forecasting/reports/monthly-expenses-projection-report',
    name: 'forecasting-reports-monthly-expenses-projection-report',
    component: MonthlyExpensesProjectionReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Actual Monthly Report --------------------*
  {
    path: '/forecasting/reports/actual-monthly-report',
    name: 'forecasting-reports-actual-monthly-report',
    component: ActualMonthlyReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Actual Monthly Income Report --------------------*
  {
    path: '/forecasting/reports/actual-monthly-income-report',
    name: 'forecasting-reports-actual-monthly-income-report',
    component: ActualMonthlyIncomeReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Actual Monthly Expenses Report --------------------*
  {
    path: '/forecasting/reports/actual-monthly-expenses-report',
    name: 'forecasting-reports-actual-monthly-expenses-report',
    component: ActualMonthlyExpensesReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Consultants By Employer --------------------*
  {
    path: '/forecasting/reports/employer-consultants',
    name: 'forecasting-reports-employer-consultants',
    component: ConsultantsByEmployer,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Consultants By Sub-Vendor --------------------*
  {
    path: '/forecasting/reports/subvendor-consultants',
    name: 'forecasting-reports-subvendor-consultants',
    component: ConsultantsBySubVendor,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Consultants By Supplier --------------------*
  {
    path: '/forecasting/reports/supplier-consultants',
    name: 'forecasting-reports-supplier-consultants',
    component: ConsultantsBySupplier,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Consultants By Referrer --------------------*
  {
    path: '/forecasting/reports/referrer-consultants',
    name: 'forecasting-reports-referrer-consultants',
    component: ConsultantsByReferrer,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Consultants By Vendor --------------------*
  {
    path: '/forecasting/reports/vendor-consultants',
    name: 'forecasting-reports-vendor-consultants',
    component: ConsultantsByVendor,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Missing Timesheets Report --------------------*
  {
    path: '/forecasting/reports/missing-timesheets',
    name: 'forecasting-reports-missing-timesheets',
    component: MissingTimesheetsReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Missing Invoices Report --------------------*
  {
    path: '/forecasting/reports/missing-invoices',
    name: 'forecasting-reports-missing-invoices',
    component: MissingInvoicesReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
  // *------------ Invoice Payment Due Date Report --------------------*
  {
    path: '/forecasting/reports/invoice-payment-due-date',
    name: 'forecasting-reports-invoice-payment-due-date',
    component: InvoicePaymentDueDateReport,
    meta: {
      navActiveLink: 'forecasting-reports',
    },
  },
]
